// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker (production only) — this is what lets
// phones offer "Install app" / "Add to Home Screen" for Mbaa Mwendwa,
// and it's also how updates reach everyone automatically (see below).
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .then((registration) => {
        // A member may leave the app open (or backgrounded, common for an
        // installed PWA) for days. The service worker's own network-first
        // handling means it WILL fetch a newer index.html on the next
        // navigation — but if they never navigate (just resume the same
        // open tab), we need to actively check, and then reload once the
        // new version has taken over. This is what makes updates reach
        // people automatically, with no manual refresh required.

        // Check right away, and again whenever they bring the app to the
        // foreground (covers "phone was asleep for two days" case).
        registration.update();
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') registration.update();
        });

        // When the new service worker actually takes control, reload once
        // so the running app matches what's now cached/served. Guarded so
        // a misbehaving worker can't cause a reload loop.
        let hasReloaded = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (hasReloaded) return;
          hasReloaded = true;
          window.location.reload();
        });
      })
      .catch((err) => console.error('Service worker registration failed:', err));
  });
}
